import { ConfigService } from './config.service';
import { NgModule } from '@angular/core';

@NgModule({
    providers: [ConfigService]
})
export class SharedServicesModule { }